module.exports = __webpack_public_path__ + "img/s2.fbc2b9cf.jpg";